import React from 'react';
import DocumentMeta from 'react-document-meta';

//Components
import HomeCarousel 	from '../Components/HomeCarousel';
import FeaturedProducts from '../Components/FeaturedProducts';
import KeyMakersBanner 	from '../Components/KeyMakersBanner';
import RepairBanner 	from '../Components/RepairBanner';

class Home extends React.Component {


	render() {
		
		const meta = {
			title: 			'Velkommen til en ny verden af cykler, fordi vi gør forskel',
			description: 	'Hos Alaska cykler åbner vi dørene for en ny verden af cykelkultur. Vi tilbyder et bredt udvalg af kvalitetscykler og cykeltilbehør i København.',
			canonical: 		window.location.href,
			meta: {
				charset: 	'utf-8',
				name: {
					keywords: 'cykler københavn, cykel reparation københavn, alaska cykler, nøgle maker københavn'
				}
			}
	    };
		
		return (
			<div className="main-content" id="home-page">

				<DocumentMeta {...meta} />

				<HomeCarousel />
				
				<div className="scroll-stop"></div>

				<FeaturedProducts />
				
				<KeyMakersBanner />
				
				<RepairBanner />
				
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/Pages/Home.js